/** Phones: the pages that do not fit the five bottom tabs, plus language and sign-out. */
import { useApp } from '../context.tsx';
import { supabase } from '../supabase.ts';

export function More(props: { readonly onToggleLanguage: () => void }) {
  const { t } = useApp();
  return (
    <section aria-labelledby="more-title" className="stack" style={{ gap: 12 }}>
      <h1 id="more-title">{t('moreTitle')}</h1>
      <ul className="more-list">
        <li>
          <a href="#/branches">{t('navBranches')}</a>
        </li>
        <li>
          <a href="#/settings">{t('navSettings')}</a>
        </li>
        <li>
          <a href="#/health">{t('navHealth')}</a>
        </li>
        <li>
          <button type="button" onClick={props.onToggleLanguage}>
            {t('switchLanguage')}
          </button>
        </li>
        <li>
          <button type="button" onClick={() => void supabase.auth.signOut()}>
            {t('signOut')}
          </button>
        </li>
      </ul>
    </section>
  );
}
